import { combineReducers } from 'redux';
import Api from './Api';
import Auth from './Auth';
import Theme from './Theme';
import Common from './Common'

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    api: Api,
    common: Common
});

export default reducers;